import { Controller } from "@hotwired/stimulus"

// localStorage 기반 dismissable 안내 — [닫기] 한 번 누르면 영구 hide.
// 사용법:
//   <div data-controller="dismissable"
//        data-dismissable-key-value="reeval-info">
//     <button data-action="click->dismissable#dismiss">×</button>
//   </div>
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (this.dismissed()) {
      this.element.classList.add("hidden")
    }
  }

  dismiss() {
    if (this.keyValue) {
      localStorage.setItem(`dismissable:${this.keyValue}`, "true")
    }
    this.element.classList.add("hidden")
  }

  dismissed() {
    return this.keyValue && localStorage.getItem(`dismissable:${this.keyValue}`) === "true"
  }
}
